// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"605":"72df55cea2effb0b","2259":"e4d85f0514fd7c2e","3283":"f2ef54198dad0ace","4689":"115275ee1fdbd3ee","8795":"7dc24718f885f7c7"}[chunkId] + ".js";
};